import * as React from 'react';

function PaginationStatus(_a) {
  var _b = _a.pagination,
      offset = _b.offset,
      limit = _b.limit,
      totalItems = _b.totalItems;
  var start = offset + 1;
  var end = Math.min(offset + limit, totalItems);
  var total = totalItems;
  return React.createElement("div", {
    "data-test": "pagination-status"
  }, totalItems > 0 ? "Showing " + start + "\u2013" + end + " of " + total + " results" : "Showing 0 results");
} //@ts-ignore until typings in place


export default React.memo(PaginationStatus);